module.exports = __webpack_public_path__ + "3-65.jpg?970efab125b1806ba19dc70c01e0e7fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-65.jpg
// module id = 147
// module chunks = 0